import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const Home = lazy(() => import('../pages/home/page'));
const Features = lazy(() => import('../pages/features/page'));
const About = lazy(() => import('../pages/about/page'));
const Privacy = lazy(() => import('../pages/privacy/page'));
const Login = lazy(() => import('../pages/login/page'));
const Dashboard = lazy(() => import('../pages/dashboard/page'));
const Students = lazy(() => import('../pages/students/page'));
const StudentProfile = lazy(() => import('../pages/student-profile/page'));
const IEPDraft = lazy(() => import('../pages/iep-draft/page'));
const Goals = lazy(() => import('../pages/goals/page'));
const ProgressTracking = lazy(() => import('../pages/progress-tracking/page'));
const ServiceLogs = lazy(() => import('../pages/service-logs/page'));
const Reports = lazy(() => import('../pages/reports/page'));
const Settings = lazy(() => import('../pages/settings/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/features',
    element: <Features />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/privacy',
    element: <Privacy />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/dashboard',
    element: <Dashboard />,
  },
  {
    path: '/students',
    element: <Students />,
  },
  {
    path: '/student/:id',
    element: <StudentProfile />,
  },
  {
    path: '/iep-draft/:id',
    element: <IEPDraft />,
  },
  {
    path: '/goals',
    element: <Goals />,
  },
  {
    path: '/progress-tracking',
    element: <ProgressTracking />,
  },
  {
    path: '/service-logs',
    element: <ServiceLogs />,
  },
  {
    path: '/reports',
    element: <Reports />,
  },
  {
    path: '/settings',
    element: <Settings />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
